import t, { Intl } from '@jetshop/intl';
import React from 'react';
import { useQuery } from 'react-apollo';
import CategoryList from '../StartPage/CategoryList';
import EmptySearchCategoriesQuery from './EmptySearchCategoriesQuery.gql';
import PageHeader from '../Layout/PageHeader/PageHeader';

const EmptySearchResults = ({ term, result }) => {
  const { data, loading } = useQuery(EmptySearchCategoriesQuery, {
    variables: { levels: 1, includeHidden: false }
  });

  return (
    <>
      <Intl>
        {t => (
          <PageHeader
            title={t('Search results')}
            content={t.rich(`Your search for {term} yielded 0 hits.`, {
              term: <b key="boldTerm">'{term}'</b>
            })}
          />
        )}
      </Intl>
      {!loading && data ? (
        <CategoryList
          title={t('Shop by category')}
          categories={data.categories}
        />
      ) : null}
    </>
  );
};

export default EmptySearchResults;
